/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../../../components/baseClasses/dataMaintenanceSectionBase.ts" />

module Meevo.Plugins.MarketPricing {
    "use strict";

    export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.DataMaintenance> {

        constructor(protected params: Meevo.Model.ISectionParamsBaseDataService) {

            super(params.sectionId,
                params.displayNameContentKey,
                params.template,
                params.isPrimarySection,
                params.handlesOwnCrud,
                params.baseEndpoint,
                params.sectionEndpoint,
                params.loggingService,
                params.dataService,
                params.identityService,
                params.noun,
                params.appSettings,
                params.sectionSecurityKey
                );
        }

        /**
         * Base class override which defines what a DEFAULT model looks like.
         */
        createSectionModelInstance(postAdd: (data: any) => any): void {
            this.dataService.getTemplate(this.params.baseEndpoint).then((data) => {
                this.model = data;
            });
        }

        stateSwitch(): void {
            if (this.model['isDefault'] || this.model['availableAtLocations'] > 0) {
                this.params.modalService.alert('MESSAGE_PRICE_MANAGEMENT_HAS_LOCATIONS').then(()=> {
                    this.model.objectState = Meevo.Model.ObjectStateEnum.Active;
                });
            }
        }
    }
}